export default "__VITE_ASSET__DmS$exqx__"